import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_ISSUE_LOG, GET_ISSUE_LOG_SUCCESS, GET_ISSUE_LOG_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getIssueLog({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* GET with a JSON body — matches the endpoint's contract: { sub_category_id, user_id } */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/issue-log`,
      method: 'GET',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_ISSUE_LOG_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ISSUE_LOG_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ISSUE_LOG_ERROR, payload: error });
  }
}

export function* watchGetIssueLog() {
  yield takeEvery(GET_ISSUE_LOG, getIssueLog);
}

function* getIssueLogSaga() {
  yield all([fork(watchGetIssueLog)]);
}

export default getIssueLogSaga;
